<script>
import ScheduleList from '../SchedulesList'
export default {
  name: 'scheduled-schedules',
  extends: ScheduleList,
  computed: {
    tabSchedule () {
      return this.$store.getters.canceledSchedule
    }
  },
  mounted () {
    if (this.$store.getters.canceledSchedule.length === 0) {
      this.$store.dispatch('getCanceledSchedule')
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?2ddd1df8